import { IBreadcrumbDataFromListing } from '@/types/data-objects/global'
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

export default new class BreadcrumbAssistant {
  public fromAll(route: any, store: any): boolean {
    return route.params.from_all
  }

  public fromEntityLanding(route: any, store: any): boolean {
    return (
      (route.params.from_entity_home || route.params.from_kanban_board) &&
      this.lastVisitedBreadcrumbDataFromListing(store) !== null
    )
  }

  public lastVisitedBreadcrumbDataFromListing(
    store: any,
  ): IBreadcrumbDataFromListing {
    return store.get('app/lastVisitedBreadcrumbDataFromListing')
  }

  public lastVisitedBreadcrumbItemMenuItems(store: any) {
    return store.get('app/lastVisitedBreadcrumbItemMenuItems')
  }

  public cacheBreadcrumbDataFromListing(
    store: any,
    data: IBreadcrumbDataFromListing,
  ) {
    store.set('app/lastVisitedBreadcrumbDataFromListing', data)
  }

  public cacheBreadcrumbItemMenuItems(
    store: any,
    data: IBreadcrumbItemMenuItem[],
  ) {
    store.set('app/lastVisitedBreadcrumbItemMenuItems', data)
  }

  public getPreviousBreadcrumbItem(
    curRefNumber: Number,
    store: any,
  ): IBreadcrumbItemMenuItem {
    const breadcrumbItems = this.lastVisitedBreadcrumbItemMenuItems(
      store,
    ) as IBreadcrumbItemMenuItem[]

    if (breadcrumbItems === null) {
      return null
    }

    const curIndex = breadcrumbItems.findIndex(
      i => i.refNumber === curRefNumber,
    )

    if (curIndex > 0) {
      return breadcrumbItems[curIndex - 1]
    }

    return null
  }

  public getNextBreadcrumbItem(
    curRefNumber: Number,
    store: any,
  ): IBreadcrumbItemMenuItem {
    const breadcrumbItems = this.lastVisitedBreadcrumbItemMenuItems(
      store,
    ) as IBreadcrumbItemMenuItem[]

    if (breadcrumbItems === null) {
      return null
    }

    const curIndex = breadcrumbItems.findIndex(
      i => i.refNumber === curRefNumber,
    )

    if (curIndex >= 0 && curIndex < breadcrumbItems.length - 1) {
      return breadcrumbItems[curIndex + 1]
    }

    return null
  }
}()
